export default __webpack_public_path__ + "static/media/eye_black.10d1b8c0.svg";